module.exports = __webpack_public_path__ + "img/pause.ef5e7766.svg";